import React from 'react';
import { ChevronDown } from 'lucide-react';
export const Testimonials = () => {
  const scrollToSignup = () => {
    const element = document.getElementById('signup');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const testimonials = [{
    author: 'Oana Baetica',
    title: 'PR & Communications Manager',
    linkedin: 'https://www.linkedin.com/in/technicalprconsultant/',
    image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4fc3a367-e3b8-4784-bea9-8f535505ab88/576afe7f-c6ef-4711-949d-af7913a3fc92/Oana.jpg',
    quote: 'This team respects my personal brand and has never spammed my network.'
  }];
  return <section className="w-full bg-white py-16" data-id="element-389">
      <div className="max-w-4xl mx-auto px-4" data-id="element-390">
        <h2 className="text-3xl font-bold text-center mb-12" data-id="element-391">
          What Our Users Say
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-392">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 rounded-lg p-6" data-id="element-393">
              <div className="flex items-center mb-4" data-id="element-394">
                <img src={testimonial.image} alt={testimonial.author} className="w-16 h-16 rounded-full mr-4 object-cover" data-id="element-395" />
                <div data-id="element-396">
                  <a href={testimonial.linkedin} target="_blank" rel="noopener noreferrer" className="font-semibold text-emerald-600 hover:text-emerald-700 hover:underline block" data-id="element-397">
                    {testimonial.author}
                  </a>
                  <span className="text-gray-600 text-sm" data-id="element-398">
                    {testimonial.title}
                  </span>
                </div>
              </div>
              <blockquote className="text-gray-600 italic" data-id="element-399">
                "{testimonial.quote}"
              </blockquote>
            </div>)}
        </div>
        <div className="text-center mb-12" data-id="element-400">
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-401">
            We value your trust. We'll never access your private messages
            without consent, and we only post content you approve. Cancel
            anytime with no strings attached.
          </p>
        </div>
        <div className="text-center" data-id="element-402">
          <h3 className="text-2xl font-bold mb-6" data-id="element-403">
            Ready to earn 150+ EUR/month with minimal effort?
          </h3>
          <button onClick={scrollToSignup} className="inline-flex items-center px-8 py-4 text-lg font-semibold text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 transition-colors" data-id="element-404">
            Sign Up Now
            <ChevronDown className="ml-2 h-5 w-5" data-id="element-405" />
          </button>
        </div>
      </div>
    </section>;
};